import ReactGA from "react-ga4";

const GA4_MEASUREMENT_ID = "G-SXNW4XHP8P";

export const initGA = () => {
  if (process.env.NODE_ENV === "production") {
    ReactGA.initialize(GA4_MEASUREMENT_ID);
  }
};

export const trackPageView = (path) => {
  if (process.env.NODE_ENV === "production") {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

export const trackEvent = (category, action, label) => {
  if (process.env.NODE_ENV === "production") {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  }
};
